import { Components, Theme } from '@mui/material';

export const MuiTypography: Components<Theme>['MuiTypography'] = {
  defaultProps: {
    variantMapping: {
      'watchduty-section-header': 'h3',
    },
  },
  variants: [
    {
      // Bold h3 with card gutters and a divider underneath, used to title a section inside a drawer or card
      props: { variant: 'watchduty-section-header' },
      style: ({ theme }) => ({
        ...theme.typography.h3,
        fontWeight: theme.typography.fontWeightBold,
        padding: theme.spacing(3, 2, 2),
        borderBottom: `1px solid ${theme.vars.palette.divider}`,
      }),
    },
  ],
};
